export enum AuthPages {
  LOGIN = "/auth/login",
  SIGN_UP = "/auth/sign-up",
}
